import type { ILocatedElement } from 'clickim/src/background/codeSnippets/getLocatedElement';

declare function getLocatedElement(locatedElement: ILocatedElement | string): Element | null;
declare function isNativeFunction(fn: any): boolean;

export function selectOption(locatedElement: ILocatedElement, dispatchEventOnSelectElement: boolean) {
    function closest(el: Element, selectors: string) {
        const originalMatches = Element.prototype.matches;
        // @ts-expect-error TS seems unaware of the fact the HTMLElement has a __proto__
        // Some customers override the native Element prototype, so we need to create a new one if they messed it up.
        const matches = originalMatches && isNativeFunction(originalMatches) ? originalMatches : document.createElement(el.tagName).__proto__.matches; // eslint-disable-line no-proto
        do {
            if (matches.call(el, selectors)) return el as HTMLSelectElement;
            el = el.parentElement || el.parentNode as HTMLElement;
        } while (el !== null && el.nodeType === 1);
        return null;
    }

    try {
        // This code depends on pre-injecting this function as well.
        const optionEl = getLocatedElement(locatedElement) as HTMLOptionElement | null;
        if (!optionEl) {
            return { success: false, status: 'failed', result: 'option element not found' };
        }

        const selectEl = closest(optionEl, 'select');
        if (!selectEl) {
            return { success: false, status: 'failed', result: 'select element not found' };
        }
        selectEl.focus();
        if (optionEl.selected) {
            return { success: true, status: 'done' };
        }
        optionEl.selected = true;

        const events = [
            'input',
            'change',
        ];
        events.map((userEvent) => {
            const event = document.createEvent('HTMLEvents');
            event.initEvent(userEvent, true, false);
            return event;
        }).forEach((event) => {
            if (dispatchEventOnSelectElement) {
                selectEl.dispatchEvent(event);
                return;
            }
            optionEl.dispatchEvent(event);
        });

        return { success: true, status: 'done' };
    } catch (err) {
        return { success: false, status: 'failed', result: err.toString() };
    }
}
